/**
 * React Query hooks for settings
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { settingsApi } from '../api/settings'
import type { UserProfileUpdate, UserPreferencesUpdate } from '../types'

const PROFILE_KEY = ['profile']
const PREFERENCES_KEY = ['preferences']

export function useUserProfile() {
  return useQuery({
    queryKey: PROFILE_KEY,
    queryFn: settingsApi.getProfile,
  })
}

export function useUpdateUserProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UserProfileUpdate) => settingsApi.updateProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROFILE_KEY })
    },
  })
}

export function useUserPreferences() {
  return useQuery({
    queryKey: PREFERENCES_KEY,
    queryFn: settingsApi.getPreferences,
  })
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UserPreferencesUpdate) => settingsApi.updatePreferences(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREFERENCES_KEY })
    },
  })
}
